module.exports = __webpack_public_path__ + "c82bdf35dc56070e49a78fc311508519.pdf";